import React from 'react';
import classnames from 'classnames';

import "./scrapbook-export-button.scss";
import { ScrapbookStore } from '../../store/ScrapbookStore';
import { IScrapbook } from '../../models/IScrapbook';

export interface IProps {
    store: ScrapbookStore;

    scrapbook: IScrapbook;

}

export interface IState {
    isMenuOpen: boolean;
}

export class ScrapbookExportButton extends React.Component <IProps, IState> {
    private root: HTMLElement;
    private menu: HTMLElement;
    private hasBeenMounted: boolean;
    
    constructor(props: IProps) {
        super(props);

        this.onRef = this.onRef.bind(this);
        this.onMenuRef = this.onMenuRef.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onExportButtonClick = this.onExportButtonClick.bind(this);

        this.onAsPdfClick = this.onAsPdfClick.bind(this);
        this.onAsJsonClick = this.onAsJsonClick.bind(this);
        
        this.state = {
            isMenuOpen: false
        };
    }

    public render(){        
        return <div className={classnames("scrapbook-export-button-root", {"_menu-opened": this.state.isMenuOpen})} ref={this.onRef}>
                    <button onClick={this.onExportButtonClick}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.9501 13.625V17.15H2.85006V13.625H0.500061V17.15C0.500061 18.4424 1.55756 19.5 2.85006 19.5H16.9501C18.2426 19.5 19.3001 18.4424 19.3001 17.15V13.625H16.9501ZM15.7751 8.92495L14.1183 7.2682L11.0751 10.2997V0.699951H8.72506V10.2997L5.68181 7.2682L4.02506 8.92495L9.90006 14.8L15.7751 8.92495Z" fill="currentColor"/>
                        </svg>
                    </button>
                    { this.renderMenu()}
               </div>
    }

    private renderMenu(){
        if(!this.state.isMenuOpen) { 
            document.removeEventListener("click", this.onDocumentClick);
            document.removeEventListener("keydown", this.onKeyDown);
            return null; 
        }
        
        return <div className="_menu" ref={this.onMenuRef}>
                    <button onClick={this.onAsPdfClick}>as pdf</button>
                    <button onClick={this.onAsJsonClick}>as json</button>
                    <div className="_menu-tip"></div>
                </div>
    }

    private onAsPdfClick(){
        this.setState({
            isMenuOpen: false
        });

        const oldTitle = document.title;

        const currentScrapbook = this.props.store.getSelectedScrapbook();
        if(currentScrapbook != null){
            document.title = `${currentScrapbook.product != null ? currentScrapbook.product.title : currentScrapbook.notebook != null ? currentScrapbook.notebook.title : ""} notebook`.trim();
        }
        
        window.print();

        if(oldTitle){
            document.title = oldTitle;
        }
    }

    private onAsJsonClick(){
        this.setState({
            isMenuOpen: false
        });
        
        this.props.store.exportCurrentScrapbook();
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
        
        document.addEventListener("keydown", this.onKeyDown);
        document.addEventListener("click", this.onDocumentClick);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;

        document.removeEventListener("keydown", this.onKeyDown);
        document.removeEventListener("click", this.onDocumentClick);
    }

    private onRef(root: HTMLElement){
        this.root = root;
    }

    private onMenuRef(menu: HTMLElement){
        if(!this.menu && menu){
            document.addEventListener("click", this.onDocumentClick);
            document.addEventListener("keydown", this.onKeyDown);
        }

        if(this.menu && !menu){
            document.removeEventListener("click", this.onDocumentClick);
            document.removeEventListener("keydown", this.onKeyDown);
        }
        
        this.menu = menu;
    }

    private onExportButtonClick(){
        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    private onKeyDown(e){
        if(!this.hasBeenMounted || !this.state.isMenuOpen) { return;  }
        
        if((e.keyCode || e.which) == 27){
            this.setState({
                isMenuOpen: false
            });
        }
    }

    private onDocumentClick(e){
        if(!this.hasBeenMounted || !this.state.isMenuOpen) { return;  }
        
        if(this.root != null){
            if(this.menu != e.target 
            && !this.menu.contains(e.target)
            && !this.root.contains(e.target)){
                this.setState({
                    isMenuOpen: false
                });
            }
        }
    }
}